import { useIM } from '@wui/im'
import { useRouter } from 'vue-router'

import { useStoreRooms } from '@/entities/room'

import { useUserFeatures } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { fromPServedUser } from '@/shared/utils/uri'
import type { InviteTokenSource } from '@/shared/utils/url'

import { ensureConferenceRoomAccess } from './ensure-conference-room-access'

export const useJoinInviteLinkRoom = () => {
  const router = useRouter()
  const storeRooms = useStoreRooms()
  const { subscribeOnConferenceUpdates } = useIM()
  const { isChatMessagingUiEnabled } = useUserFeatures()

  const joinInviteLinkRoom = async (invite: InviteTokenSource) => {
    const roomId = fromPServedUser(invite.roomPServed)
    const hasAccess = await ensureConferenceRoomAccess(roomId, {
      resolveRoom: (id) => storeRooms.getRoomById(id) ?? storeRooms.findByPServed(invite.roomPServed),
      intent: invite.prepareToCall ? 'prepare-to-call' : 'chat',
      skipChatNavigation: !!invite.prepareToCall,
    })

    if (!hasAccess) {
      return
    }

    await subscribeOnConferenceUpdates({ pServed: invite.roomPServed })

    if (invite.prepareToCall) {
      await router.push({
        name: pathNames.PREPARE_TO_CALL,
        params: { roomId },
        state: { conferenceRoomAccessChecked: true },
      })
      return
    }

    if (isChatMessagingUiEnabled.value) {
      await router.push({ name: pathNames.CHAT, params: { id: btoa(roomId) }})
    }
  }

  return { joinInviteLinkRoom }
}
